import React from 'react';
import { BaseButton, useT } from '@repo/common';

const BottomButton = ({ onCancel, onSave }) => {
  const t = useT();
  return (
    <div className='flex max-w-[568px] justify-end items-center gap-2 pb-[60px]'>
      <BaseButton
        type='secondary'
        size='l'
        hideIcon
        onClick={onCancel}
        bgclass='bg-transform'
      >
        {t('Cancel', '취소')}
      </BaseButton>
      <BaseButton size='l' hideIcon onClick={onSave}>
        {t('Save Profile', '프로필 저장')}
      </BaseButton>
    </div>
  );
};

export default BottomButton;
